class IngredientsBlogGrid {
  constructor() {
    this.init();
  }

  init() {
    this.initSwiper();
    this.initPopup();
    this.initFilterDropdown();
    this.initResizeHandler();
  }

  initSwiper() {
    let swiperInstance = null;
    const isMobile = window.innerWidth <= 989;
    const swiperContainer = document.querySelector('.swiper');

    if (isMobile && !swiperInstance) {
      swiperInstance = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    } else if (!isMobile && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  initPopup() {
    const popup = document.querySelector('.article-popup');
    const popupClose = popup.querySelector('.popup-close');
    const popupOverlay = popup.querySelector('.popup-overlay');
    const popupBanner = popup.querySelector('.popup-banner img');
    const popupContent = popup.querySelector('.popup-body .article-content');

    document.querySelectorAll('.learn-more-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Update popup content
        popupBanner.src = btn.dataset.articleImage;
        popupBanner.alt = btn.dataset.articleTitle;
        popupContent.innerHTML = btn.dataset.articleContent;
        
        // Show popup with fade effect
        popup.style.display = 'block';
        requestAnimationFrame(() => {
          popup.classList.add('active');
        });
        document.body.style.overflow = 'hidden';
      });
    });

    const closePopup = () => {
      popup.classList.remove('active');
      setTimeout(() => {
        popup.style.display = 'none';
        document.body.style.overflow = '';
      }, 300); // Match the transition duration
    };

    popupClose.addEventListener('click', closePopup);
    popupOverlay.addEventListener('click', closePopup);
  }

  initFilterDropdown() {
    const dropdown = document.getElementById('ingredients_filter_dropdown_nav');
    if (dropdown) {
      dropdown.addEventListener('change', function() {
        const url = this.value;
        if (url) {
          window.location.href = url;
        }
      });
    }
  }

  initResizeHandler() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.initSwiper(), 300);
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new IngredientsBlogGrid();
}); 